import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';
import { BehaviorService } from '@_services/Behavior.service';
import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { ConfirmPopupComponent } from 'src/app/main/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-miscellaneous',
  templateUrl: './miscellaneous.component.html',
  styleUrls: ['./miscellaneous.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MiscellaneousComponent implements OnInit {
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  manuopenste: boolean;
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  confirmDialogRef: any;
  @ViewChild('xerodatepicker', { static: false })
  datePicker: MatDatepicker<Date>;
  constructor(
    private behaviorService: BehaviorService,
    public _matDialog: MatDialog,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('miscellaneous');
  }

  /**
   * This function is used to support the uties
   */
  supportUtilities() {
    this.trigger.openMenu();
  }

  /**
   * This function is used to sort the date
   */
  xeroSartDate() {
    this.confirmDialogRef = this._matDialog.open(ConfirmPopupComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage =
      'This Will set the first date for data to be synced to Xero. \n Are you Sure ? ';
    this.confirmDialogRef.componentInstance.confirmTitle = 'Set Xero Sart Date';
    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.datePicker.open();
      }
      this.confirmDialogRef = null;
    });
  }
}
